















import FeedbackComponent from '@/components/base/FeedbackComponent'
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {ExportType} from '@payroll/grid-widget/src/models/ExportType'
import {GridColumn} from '@payroll/grid-widget/src/models/GridColumn'
import {KeyValuePair} from '@payroll/optimus-common';
import {FieldType, SearchFieldModel} from "@payroll/search-results-widget/src/models/SearchField.model";
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator';
import {Action} from "vuex-class";

@Component({
  components: {}
})
export default class MemberSecurities extends FeedbackComponent {

  @Action('getMemberSecurities', StoreNamespace.CUSTOMER_SERVICE) getMemberSecurities: any
  @Action('getMemberSecuritiesReport', StoreNamespace.CUSTOMER_SERVICE) getMemberSecuritiesReport: any
  @Action('getSecuritiesCaseNumbers', StoreNamespace.CUSTOMER_SERVICE) getSecuritiesCaseNumbers: any
  @Prop() memberIdNum!: string

  private ExportType = ExportType

  private searchObject: any = {}

  private columns: GridColumn[] = []

  mounted() {
    if (this.memberIdNum) {
      this.initColumns();
      this.getCaseNumbers()
    }
  }

  private searchFields: SearchFieldModel[] = []
  private selectedCaseNumber: KeyValuePair | null = null
  private caseNumbers: [] = []

  sumCurrencyValues(values: string[]): string {
    // Initialize a variable to store the sum
    let sum = 0;

    // Loop through the array of strings
    for (const value of values) {
      // Remove non-numeric characters and replace the comma with a dot (for parsing as a float)
      const numericValue = parseFloat(value.replace(/[^\d.]/g, '').replace(',', '.'));

      // Add the numeric value to the sum
      if (!isNaN(numericValue)) {
        sum += numericValue;
      }
    }

    const formattedSum = sum.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return formattedSum;
  }


  private getCaseNumbers() {
    this.getSecuritiesCaseNumbers({
      pathVariable: this.memberIdNum,
      requestorCallback: this,
    })
  }

  initSearchFields(): void {
    this.searchFields = []

    this.searchFields.push({
      label: 'securities.caseNumber',
      property: 'caseNumber',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: this.caseNumbers,
      bootstrapColumn: 3
    })
  }


  private initColumns(): void {
    this.columns.push({
      property: 'caseNumber',
      header: 'securities.caseNumber',
      hideSorting: true
    } as GridColumn);
    this.columns.push({
      property: 'paperName',
      header: 'securities.paperName',
      hideSorting: true
    } as GridColumn);
    this.columns.push({
      property: 'paperNumber',
      header: 'securities.paperNumber',
      hideSorting: true
    } as GridColumn);
    this.columns.push({
      property: 'eisenNumber',
      header: 'securities.eisenNumber',
      hideSorting: true
    } as GridColumn);
    this.columns.push({
      property: 'amount',
      header: 'securities.amount',
      hideSorting: true
    } as GridColumn);
    this.columns.push({
      property: 'lastGate',
      header: 'securities.lastGate',
      hideSorting: true
    } as GridColumn);
    this.columns.push({
      property: 'holdingValueInNis',
      header: 'securities.holdingValueInNIS',
      hideSorting: true
    } as GridColumn);
  }


  private getGridData(searchObject: any) {
    searchObject.pageSize = 1000
    searchObject.memberIdNum = this.memberIdNum

    this.searchObject = searchObject

    this.getMemberSecurities({
      requestorCallback: this,
      requestBody: searchObject,
    });
  }

  onSuccess(data?: any, requestName?: string, message?: string, success?: boolean): void {
    switch (requestName) {
      case 'findMembersOrEmployersFor/memberSecurities':
        data.summary = {
          holdingValueInNis: this.sumCurrencyValues(data.results.map((res: any) => res.holdingValueInNis)),
          lastGate: this.$t('securities.sumOfHoldingValueInNIS'),
          summaryValue: 'holdingValueInNis',
          isCurrency: true
        };

        this.$emit('successResults', data)
        break;

      case 'findMembersOrEmployersFor/memberCaseNumbers':
        if (data.length > 0) {
          this.caseNumbers = data
          this.selectedCaseNumber = data[0]
          this.initSearchFields()
          this.getGridData({
            pageNumber:0,
            pageSize:1000,
            caseNumber:this.selectedCaseNumber
          })
        }
        break

      case 'findMembersOrEmployersFor/memberSecuritiesReport':
        this.$emit('successExport', data)
        break;
    }
  }

  onExportClick(exportType: any, gridColumns: any) {

    this.getMemberSecuritiesReport({
      requestorCallback: this,
      requestBody: this.searchObject,
    })
  }

  get exportFileName(): string {
    return '' + this.$t('securities.title')
  }
}


